"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldType = void 0;
var FieldType;
(function (FieldType) {
    FieldType["Address"] = "Address";
    FieldType["AutoNumber"] = "Auto Number";
    FieldType["Checkbox"] = "Checkbox";
    FieldType["ComplexValue"] = "Complex Value";
    FieldType["Content"] = "Content";
    FieldType["Currency"] = "Currency";
    FieldType["Date"] = "Date";
    FieldType["DateTime"] = "Date/Time";
    FieldType["Email"] = "Email";
    FieldType["Encrypted"] = "Encrypted";
    FieldType["ExternalLookup"] = "External Lookup";
    FieldType["Fax"] = "Fax";
    FieldType["File"] = "File";
    FieldType["Formula"] = "Formula";
    FieldType["Geolocation"] = "Geolocation";
    FieldType["Hierarchy"] = "Hierarchy";
    FieldType["Html"] = "Html";
    FieldType["IndirectLookup"] = "Indirect Lookup";
    FieldType["IpAddress"] = "IP Address";
    FieldType["LongTextArea"] = "Long Text Area";
    FieldType["Lookup"] = "Lookup";
    FieldType["MasterDetail"] = "Master-Detail";
    FieldType["MetadataRelationship"] = "Metadata Relationship";
    FieldType["MultiselectPicklist"] = "Multiselect Picklist";
    FieldType["Name"] = "Name";
    FieldType["Number"] = "Number";
    FieldType["Percent"] = "Percent";
    FieldType["Phone"] = "Phone";
    FieldType["Picklist"] = "Picklist";
    FieldType["RichTextArea"] = "Rich Text Area";
    FieldType["RollUpSummary"] = "Roll-Up Summary";
    FieldType["Summary"] = "Summary";
    FieldType["Text"] = "Text";
    FieldType["TextArea"] = "TextArea";
    FieldType["Time"] = "Time";
    FieldType["Url"] = "Url";
})(FieldType || (exports.FieldType = FieldType = {}));
//# sourceMappingURL=FieldType.js.map